import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/shared/ui';

interface WorkspaceWhitelistRulesHeaderProps {
  searchValue: string;
  rulesCount: number;
  onSearchChange: (value: string) => void;
  onAddClick: () => void;
}

export const WorkspaceWhitelistRulesHeader = ({
  searchValue,
  rulesCount,
  onSearchChange,
  onAddClick,
}: WorkspaceWhitelistRulesHeaderProps) => {
  const { t } = useTranslation('admin');
  const searchLabel = t('admin.workspaceWhitelistRulesHeader.searchWorkspaceRulesLabel');

  return (
    <div className="flex flex-row gap-4 justify-between items-center">
      <div className="flex flex-col">
        <h2 className="text-base font-medium leading-6 text-foreground">
          {t('admin.workspaceWhitelistRulesHeader.workspaceRules', { rulesCount })}
        </h2>
        <p className="text-base text-muted-foreground mt-2 leading-6">
          {t('admin.workspaceWhitelistRulesHeader.restrictSpecificWorkspacesToUse')}
        </p>
      </div>
      <div className="flex flex-row gap-4 items-center">
        <SearchInput
          placeholder={t('admin.workspaceWhitelistRulesHeader.searchWorkspaceRules')}
          aria-label={searchLabel}
          onChange={onSearchChange}
          value={searchValue}
          clearable
          className="w-72"
        />
        <Button onClick={onAddClick}>
          {t('admin.workspaceWhitelistRulesHeader.addRule')}
          <PlusIcon />
        </Button>
      </div>
    </div>
  );
};
